// src/services/inviteService.js
/**
 * Service para gerenciar convites de administradores
 */
import { requestWithAuth } from "./api";

// Dominios corporativos que a TELA aceita no convite/cadastro de admin geral.
//
// Cada entrada carrega o "@" de proposito: isValidDomain casa por endsWith, e
// sem ele "x@notcesardomingues.com.br" passaria. Ha teste travando isso.
//
// NAO E CONTROLE DE ACESSO. O /auth/v1/invites/imports valida so o FORMATO do
// e-mail ([PtmEmail] -> IsValidEmail), sem allowlist, e o Google SSO nao le a
// claim "hd". Quem chamar a API direto entra com qualquer dominio bem-formado.
export const ALLOWED_DOMAINS = [
  "@portaltelemedicina.com.br",
  "@integrasaudedigital.com.br",
  "@aciges.org.br",
  // Cesar Domingues Advogados — corpo juridico.
  "@cesardomingues.com.br",
];

/**
 * Valida se o email pertence ao domínio permitido
 * @param {string} email - Email a ser validado
 * @returns {boolean} True se o email é válido
 */
export function isValidDomain(email) {
  if (!email) return false;
  const lower = email.toLowerCase();
  return ALLOWED_DOMAINS.some((domain) => lower.endsWith(domain));
}

/**
 * Envia convite para novo administrador geral
 * @param {Object} userData - Dados do usuário
 * @param {string} userData.email - E-mail do usuário
 * @param {string} userData.firstName - Nome
 * @param {string} userData.lastName - Sobrenome
 * @param {string} userData.gender - Sexo ('Male' ou 'Female')
 * @returns {Promise<Object>} Resposta da API
 */
export async function inviteGeneralAdmin(userData) {
  const { email, firstName, lastName, gender } = userData;

  // Validação do domínio
  if (!isValidDomain(email)) {
    throw new Error(
      `E-mail deve pertencer a um dos domínios: ${ALLOWED_DOMAINS.join(" ou ")}`,
    );
  }

  const payload = {
    generals: [
      {
        email: email.toLowerCase().trim(),
        first_name: firstName.trim(),
        last_name: lastName.trim(),
        gender: gender,
      },
    ],
    profile_type: 1,
  };

  const response = await requestWithAuth("/auth/v1/invites/imports", {
    method: "POST",
    body: JSON.stringify(payload),
  });

  const data = await response.json().catch(() => ({}));

  // Verifica se houve erro HTTP
  if (!response.ok) {
    throw new Error(
      data.message || `Erro ao enviar convite: ${response.status}`,
    );
  }

  // Verifica se o backend retornou falhas mesmo com status 200
  if (data.count_faileds > 0 && data.error_message?.length > 0) {
    // Extrai a mensagem de erro mais relevante
    const errorMsg = data.error_message[0];
    // Remove o email prefix se existir (formato: "email => mensagem")
    const cleanMessage = errorMsg.includes(" => ")
      ? errorMsg.split(" => ")[1]
      : errorMsg;

    const error = new Error(cleanMessage);
    error.details = data;
    throw error;
  }

  return data;
}

/**
 * Constantes de gênero
 */
export const GENDER = {
  MALE: "Male",
  FEMALE: "Female",
};

/**
 * Labels de gênero em português
 */
export const GENDER_LABELS = {
  [GENDER.MALE]: "Masculino",
  [GENDER.FEMALE]: "Feminino",
};
